export const resolvePaymentModeFromConnectStatus = (connectStatus = null) =>
  connectStatus?.chargesEnabled === true ? "card" : "cash_only";

// A payload carrying the Stripe status is resolved from it, since a stored
// paymentMode can be stale. The public profile endpoints never send the Stripe
// status, only the paymentMode the server derived from it, so without a status
// that value is the answer.
export const resolveProfessionalPaymentMode = (professional = {}) => {
  const connectStatus =
    professional?.stripeConnectStatus ||
    professional?.stripe?.connectStatus ||
    null;
  if (connectStatus) return resolvePaymentModeFromConnectStatus(connectStatus);
  return professional?.paymentMode === "card" ? "card" : "cash_only";
};

// The mode one service is booked under. A team service paid to the business
// always takes cards; anything else follows the pro's own Stripe status.
export const resolveServicePaymentMode = (service, paymentMode = "card") =>
  service?.paymentRouting?.payoutMode === "business_managed" ? "card" : paymentMode;
